// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__izT2p","tabs":"_styles_tabs__CJ4Sd","tabs_link":"_styles_tabs_link__Dtehg"};